import React, { Component } from 'react'
import styled from 'styled-components'
import { Form } from 'formsy-react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'
import { Modal, TextInput, Button, Select } from 'advenio-components'
import TimePicker from 'react-gradient-timepicker'
import HomeReportActions from '../../../Data/Redux/ParentPlatform/HomeReportRedux'
import { notificationFail } from '../../../Data/Redux/NotificationActions'
import { generateSelectOptions } from '../../../utils/Utils'
import {
  TemperatureText,
  TemperatureNumber,
  Span,
  TemperatureSlider,
  SliderDiv,
  SwitchParentContainer,
  SwitchOptions
} from '../../ModalContainer/ModalAssessment.styles'
import { HIGH_TEMPERATURE } from '../../../Constants'
import { isBoolean } from 'lodash'

const ParametersRow = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  width: 100%;
  flex-wrap: wrap;
`

const IconLabel = styled.span`
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  margin: 16px 0 16px 0;
  height: 30px;
`

const ButtonsRow = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
`

const CheckinParameters = styled.div`
  display: flex;
  flex:1;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding: 8px;

  .timepicker{
    font-size: 14px;
    line-height: 20px;
    border-radius: 5px;
    border: 1px solid #DFE3E8;
    padding: 6.5px;
    margin-top: 0.9rem;
  }
`

const Icons = styled.div`
  height: 60px;
  width: 60px;
  border-radius: 30px;
  background: rgba(175,168,204,.3);
  line-height: 5.5;

  img{
    max-height: 40px;
  }
`
const ParentContainer = styled.div`
  width: 100%;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom:10px;
  margin-top: 10px;
  padding: 10px;
`
const ParentDiv = styled.div`
  width: 100%;
  height: 80px;
  background-color: #E2E8EC;
  border-radius: 4px;
  margin-bottom: 20px;
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  font-weight: bold;
  color: #4c4c4c;
  @media (max-width: 763px) {
    height: 70px;
  }
`
const TemperatureContainer = styled.div`
  width: 100%;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 10px;
  padding: 10px;
`
const TemperatureDiv = styled.div`
  width: 100%;
  height: 100px;
  background-color: #E2E8EC;
  border-radius: 4px;
  margin-bottom: 20px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  @media (max-width: 763px) {
    height: 70px;
  }
`
const SwitchYes = styled(SwitchOptions)`
  background-color: ${props => props.active ? '#C50315' : '#b9b9b9'};
  color: ${props => props.active ? '#FFFFFF' : '#4A4A4A'};
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
`

const SwitchNo = styled(SwitchOptions)`
  background-color: ${props => props.active ? '#75B753' : '#b9b9b9'};
  color: ${props => props.active ? '#FFFFFF' : '#4A4A4A'};
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
`
const Content = styled.div`
  flex: 1;
  height: 100px;
  overflow-x: hidden;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 30px;
`
const FormContainer = styled.div`
  padding: 16px;
  overflow-y: scroll;
`
class HomeReportDesktop extends Component {
  constructor(props) {
    super(props)

    this.state = {
      last_bottle_feed: '',
      last_diaper_change: '',
      form: {
        hours_of_sleep: '',
        observations: '',
      },
      temperature: 36.5,
      color: '#75B753',
      goTo: 'Sin Problemas',
      isSymptomPresent: false,
      isContactPresent: false,
      isTripPresent: false,
      revise: [],
      options_hours_sleep: this.props.fillOptions(18, 2),
    }
  }

  componentWillUnmount() {
    // window.removeEventListener('resize', this.updateWindowDimensions)
    if (this.scrollArea) {
      this.scrollArea.removeEventListener('scroll', this.preventIOSScroll)
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.successHomeReport !== this.props.successHomeReport) {
      if (nextProps.successHomeReport) {
        const form = {
          hours_of_sleep: '',
          observations: '',
        }

        this.setState({
          form,
          last_bottle_feed: '',
          last_diaper_change: '',
        }, () => {
          this.props.onClose()
          this.props.onAddHomeReport()
        })
      }
    }
  }
  preventIOSScroll = (e) => {
    const elem = e.currentTarget
    const top = elem.scrollTop
    const totalScroll = elem.scrollHeight
    const currentScroll = top + elem.offsetHeight

    if (top === 0) {
      elem.scrollTop = 1
    } else if (currentScroll === totalScroll) {
      elem.scrollTop = top - 1
    }
  }
  setTime = (type, val) => this.setState({ [type]: val })

  handleFormChange = form => this.setState({ form })

  handleChange = (temperature) => {
    const realValue = temperature / 10
    this.setState({ temperature: realValue }
       , () => this.changeColor()
      )
  }

  changeColor = () => {
    let count = 0
    // for (let i = 0; i < this.state.revise.length; i++) {
    //   if (this.state.revise[i].selected) {
    //     count += 1
    //   }
    // }
    // for (let i = 0; i < this.state.askParent.length; i++) {
    //   if (this.state.askParent[i].selected) {
    //     count += 1
    //   }
    // }
    if (this.state.temperature >= HIGH_TEMPERATURE) {
       this.setState({
         color: '#EA3B3B',
      //   room: '#9B9B9B',
         goTo: 'Mandar a Casa',
      //   goToMovil: 'Mandar a Casa',
      //   icon: '/assets/home_icon.svg',
       })
    } else if (this.state.temperature < HIGH_TEMPERATURE) {
      this.setState({
         color: '#75B753',
      //   room: '#75B753',
        goTo: 'Sin Problemas',
      //   goToMovil: 'Pasar a Sala',
      //   icon: '/assets/checkRoom.svg',
       })
    }
  }

  togglePresentSymptom = (e) => {
    const { id, title }  = e.currentTarget
    const { isSymptomPresent,
     isContactPresent,
     isTripPresent } = this.state
      this.setState({
        isSymptomPresent: title === "isSymptomPresent" ? Boolean(Number(id)) : isSymptomPresent,
        isContactPresent: title === "isContactPresent" ? Boolean(Number(id)) : isContactPresent,
        isTripPresent: title === "isTripPresent" ? Boolean(Number(id)) : isTripPresent,
      })

  }

  goTo = () => {
    const newState = { ...this.state }
    let home = 0
    let classroom = 0
    let nursesRoom = 0
    let count = 0
    for (let i = 0; i < newState.revise.length; i++) {
      if (newState.revise[i].selected) {
        count++
        if (newState.revise[i].destination == 'Home') {
          home++
        } else if (newState.revise[i].destination == "Nurse's Room") {
          nursesRoom++
        } else {
          classroom++
        }
      }
    }
    for (let i = 0; i < newState.extra.length; i++) {
      if (newState.extra[i].selected) {
        count++
        if (newState.extra[i].destination == 'Home') {
          home++
        } else if (newState.extra[i].destination == "Nurse's Room") {
          nursesRoom++
        } else {
          classroom++
        }
      }
    }
    for (let i = 0; i < newState.askParent.length; i++) {
      if (newState.askParent[i].selected) {
        count++
        if (newState.askParent[i].destination == 'Home') {
          home++
        } else if (newState.askParent[i].destination == "Nurse's Room") {
          nursesRoom++
        } else {
          classroom++
        }
      }
    }
    if (home > 0) {
      newState.room = '#9B9B9B'
      newState.goTo = 'Mandar a Casa'
      newState.goToMovil = 'Mandar a Casa'
      newState.icon = '/assets/home_icon.svg'
    } else if (nursesRoom > 0) {
      newState.room = '#C50315'
      newState.goTo = 'Pasar a Sintomas'
      newState.goToMovil = 'Pasar a Sintomas'
      newState.icon = '/assets/NursesRoom.svg'
    } else {
      newState.room = '#75B753'
      newState.goTo = 'Pasar a Sala'
      newState.goToMovil = 'Pasar a Sala'
      newState.icon = '/assets/checkRoom.svg'
    }
    if (count === 0) {
      newState.showParentQuestion = false
    }
    this.setState(newState)
  }

  submitCheckIn = () => {
    const { last_bottle_feed, last_diaper_change, form, isSymptomPresent, isContactPresent, isTripPresent, temperature } = this.state
    const { toastError, sendHomeReport, studentId } = this.props

    // if (form.hours_of_sleep === '') {
    //   toastError('Ingrese las horas de sueño.')
    //   return false
    // }

    // if (last_diaper_change === '') {
    //   toastError('Ingrese la hora de la ultima toma de biberón.')
    //   return false
    // }

    // if (last_bottle_feed === '') {
    //   toastError('Ingrese la hora del ultimo cambio de pañal.')
    //   return false
    // }

    const toSubmit = {
      ...form,
      last_diaper_change,
      last_bottle_feed,
      temperature,
      respiratory_disease:isSymptomPresent,
      contact_sick:isContactPresent,
      trip:isTripPresent,
    }
    sendHomeReport(studentId, toSubmit)
  }

  render() {
    const {
      onClose,
      open,
      sendingHomeReport,
      full,
    } = this.props
    const {
      last_bottle_feed,
      last_diaper_change,
      options_hours_sleep,
    } = this.state

    return (
      <Modal
        isOpened={open}
        headerTitle="Formato de entrada"
        onClose={onClose}
        smallHeader
        fullHeight={full}
      >
        <FormContainer>
          <Form
            onSubmit={() => this.submitCheckIn()}
            onChange={data => this.handleFormChange(data)}
          >
            <ParametersRow>
              <CheckinParameters>
                <Icons>
                  <img src="/assets/checkin-sleeping-hours.svg" alt="Horas de sueño" />
                </Icons>
                <IconLabel>Horas de sueño</IconLabel>
                <Select
                  name="hours_of_sleep"
                  placeholder="Seleccione"
                  fullWidth
                  value=""
                  options={options_hours_sleep}
                />
              </CheckinParameters>
              <CheckinParameters>
                <Icons>
                  <img src="/assets/checkin-baby-bottle.svg" alt="Ultima hora de biberon" />
                </Icons>
                <IconLabel>Ultima toma de biberon</IconLabel>
                <TimePicker
                  time={last_bottle_feed}
                  className="timepicker"
                  placeholder="Seleccione"
                  color1="#3E72D7"
                  headerColor="#305DB1"
                  onSet={(val) => {
                    this.setTime('last_bottle_feed', val.format24)
                  }}
                />
              </CheckinParameters>
              <CheckinParameters>
                <Icons>
                  <img src="/assets/checkin-diaper.svg" alt="Ultimo cambio de pañal" />
                </Icons>
                <IconLabel>Ultimo cambio de pañal</IconLabel>
                <TimePicker
                  time={last_diaper_change}
                  className="timepicker"
                  placeholder="Seleccione"
                  color1="#3E72D7"
                  headerColor="#305DB1"
                  onSet={(val) => {
                    this.setTime('last_diaper_change', val.format24)
                  }}
                />
              </CheckinParameters>
            </ParametersRow>
            {/* {this.state.goTo === 'Mandar a Casa' ? (
              <ParentContainer>
                <ParentDiv>
                  <span>Recomendamos no mandar al niño al centro Advenio.</span>
                  <SwitchParentContainer>
                    <SwitchYes
                      id="yes"
                      active={this.state.isParentPresent}
                      onClick={this.togglePresentParent}
                    >
                      SI
                    </SwitchYes>
                    <SwitchNo
                      id="no"
                      active={!this.state.isParentPresent}
                      onClick={this.togglePresentParent}
                    >
                      NO
                    </SwitchNo>
                  </SwitchParentContainer>
                </ParentDiv>
              </ParentContainer>
            ) : (
              ''
            )} */}
              <Content
            innerRef={(el) => {
              this.scrollArea = el
            }}
          >
            <TemperatureContainer>
              <TemperatureDiv>
                <TemperatureText>
                  <Span>TEMPERATURA</Span>
                  <TemperatureNumber>{`${this.state.temperature} ºC`}</TemperatureNumber>
                </TemperatureText>
                <TemperatureSlider>
                  <SliderDiv>
                    <Slider
                      allowCross={false}
                      min={350}
                      max={420}
                      count={1}
                      onChange={value => this.handleChange(value)}
                      trackStyle={[{ backgroundColor: this.state.color }]}
                      handleStyle={[
                        {
                          backgroundColor: '#FFFFFF',
                          border: '#FFFFFF',
                          height: '25px',
                          width: '25px',
                          marginTop: '-10px',
                        },
                      ]}
                      railStyle={{ backgroundColor: '#CCCCCC' }}
                    />
                  </SliderDiv>
                </TemperatureSlider>
              </TemperatureDiv>
            </TemperatureContainer>
          </Content>
            <ParentContainer>
              <ParentDiv>
                <span>¿Tú o tu bebé han tenido algun sintoma de vías respiratorias?</span>
                <SwitchParentContainer>
                  <SwitchYes
                    id={1}
                    active={this.state.isSymptomPresent}
                    onClick={this.togglePresentSymptom}
                    title="isSymptomPresent"
                  >
                    SI
                  </SwitchYes>
                  <SwitchNo
                    id={0}
                    active={!this.state.isSymptomPresent}
                    onClick={this.togglePresentSymptom}
                    title="isSymptomPresent"
                  >
                    NO
                  </SwitchNo>
                </SwitchParentContainer>
              </ParentDiv>
            </ParentContainer>
            <ParentContainer>
              <ParentDiv>
                <span>¿Tú o tu bebé han estado en contacto con alguna persona/familiar diagnosticado de COVID-19?</span>
                <SwitchParentContainer>
                  <SwitchYes
                    id={1}
                    active={this.state.isContactPresent}
                    onClick={this.togglePresentSymptom}
                    title="isContactPresent"
                  >
                    SI
                  </SwitchYes>
                  <SwitchNo
                    id={0}
                    active={!this.state.isContactPresent}
                    onClick={this.togglePresentSymptom}
                    title="isContactPresent"
                  >
                    NO
                  </SwitchNo>
                </SwitchParentContainer>
              </ParentDiv>
            </ParentContainer>
            <ParentContainer>
              <ParentDiv>
                <span>¿Tú o tu bebé han viajado fuera de la ciudad en los últimos 14 días?</span>
                <SwitchParentContainer>
                  <SwitchYes
                    id={1}
                    active={this.state.isTripPresent}
                    onClick={this.togglePresentSymptom}
                    title="isTripPresent"
                  >
                    SI
                  </SwitchYes>
                  <SwitchNo
                    id={0}
                    active={!this.state.isTripPresent}
                    onClick={this.togglePresentSymptom}
                    title="isTripPresent"
                  >
                    NO
                  </SwitchNo>
                </SwitchParentContainer>
              </ParentDiv>
            </ParentContainer>
            <TextInput
              name="observations"
              label="Observaciones"
              textarea
            />
            <ButtonsRow>
              <Button ghost onClick={onClose}> Cancelar</Button>
              <Button success type="submit" disabled={sendingHomeReport} loading={sendingHomeReport}> Aceptar</Button>
            </ButtonsRow>
          </Form>
        </FormContainer>
      </Modal>
    )
  }
}

HomeReportDesktop.propTypes = {
  /** Boolean Modal status */
  open: PropTypes.bool.isRequired,
  /** Id of current child */
  studentId: PropTypes.number.isRequired,
  /** Status when is sending the form data */
  sendingHomeReport: PropTypes.bool,
  /** Status of checkin when finish request */
  successHomeReport: PropTypes.bool,
  /** Boolean that determinates modal Height */
  full: PropTypes.bool.isRequired,

  /** Function for trigger when the modal is closing */
  onClose: PropTypes.func.isRequired,
  /** Function for submit the data to chech in */
  sendHomeReport: PropTypes.func.isRequired,
  /** Toast the errors notification  */
  toastError: PropTypes.func.isRequired,
  /** Return the options for select in Hours of sleep */
  fillOptions: PropTypes.func.isRequired,
  /** Function to disable the button "Agregar formato de entrada" when the entry format is added successful */
  onAddHomeReport: PropTypes.func.isRequired,
}

HomeReportDesktop.defaultProps = {
  successHomeReport: false,
  sendingHomeReport: false,
}

const mapStateToProps = state => ({
  successHomeReport: state.home_report.send_home_report.success,
  sendingHomeReport: state.home_report.send_home_report.fetching,
})

const mapDispatchToProps = dispatch => ({
  sendHomeReport: (studentId, data) =>
    dispatch(HomeReportActions.postHomeReportRequest(studentId, data)),
  toastError: message => dispatch(notificationFail(message)),
  fillOptions: (length, divide) => generateSelectOptions(length, divide),
})

export default connect(mapStateToProps, mapDispatchToProps)(HomeReportDesktop)



// WEBPACK FOOTER //
// ./src/Components/ParentPlatform/HomeReport/index.jsx